<template>
  <div class="columns is-marginless">
    <div class="column is-four-fifths is-offset-1">
      <div class="store-editor">
        <router-link to="/store/list" class="store-editor__prev-page">
          <i class="icon-chevron-left-bold" />
          返回店家管理
        </router-link>
        <h1 v-if="isCreateMode" class="store-editor__title">新增店家</h1>
        <b-loading :active="loading"/>
        <store-form :store="store" @save="saveStore" />
        <menu-list
          :menus="menus"
          :disabled="!isMenuActionAvailable" />
      </div>
    </div>
  </div>
</template>

<script>
import StoreEditor from './StoreEditor';

export default StoreEditor;
</script>

<style lang="scss" scoped>
@import 'StoreEditor';
</style>
